import { render } from "./authPasswordUpdate.vue?vue&type=template&id=8127abe8&scoped=true"
import script from "./authPasswordUpdate.vue?vue&type=script&lang=js"
export * from "./authPasswordUpdate.vue?vue&type=script&lang=js"

import "./authPasswordUpdate.vue?vue&type=style&index=0&id=8127abe8&scoped=true&lang=css"

import exportComponent from "C:\\actions-runner\\_work\\cims-billing.ui\\cims-billing.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8127abe8"]])

export default __exports__